<template>
  <div class="exam-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="exam-container">
      <div>
        <img src="/img/icons/post-exam.svg" alt="" />
        <h3 class="color-white mt-3 text-center">Post-Exam</h3>
        <p class="color-white">
          20 Soal
        </p>

        <my-button type="teal" @click="startModal = true" class="mt-3">
          <fa-icon icon="play" class="mr-1"></fa-icon>
          Mulai Post-Exam
        </my-button>
      </div>
    </div>

    <b-modal v-model="startModal" hide-footer hide-header centered>
      <modal-close @click="startModal = false"></modal-close>
      <div class="p-4 text-center">
        <img src="/img/icons/mulai-exam.svg" alt="" />
        <h3 class="text-center mt-3">Mulai Exam</h3>
        <p>Apakah kamu yakin untuk memulai exam sekarang?</p>
        <p class="passing-grade mt-2">
          Passing grade: 80
        </p>

        <my-button class="mr-2 mt-4" type="fill-blue" @click="handleYaClick">
          Ya
        </my-button>

        <my-button @click="startModal = false">
          Batal
        </my-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startModal: false,
      pagination: [
        {
          text: "SMA",
          url: "#"
        },
        {
          text: "Pelajaran SMA Kelas 12",
          url: "#"
        },
        {
          text: "KTSP",
          url: "#"
        },
        {
          text: "Matematika SMA Kelas 12",
          url: "#"
        },
        {
          text: "KTSP 2006",
          url: "#"
        },
        {
          text: "Bab 1 - Integral",
          url: "#"
        }
      ]
    };
  },
  methods: {
    handleYaClick() {
      
    }
  }
};
</script>

<style>
.exam-container {
  height: calc(100vh - 175px);
  background-image: linear-gradient(
    59deg,
    #56c8ff 1%,
    #2190e9 53%,
    #00cbae 114%
  );

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.passing-grade {
  font-size: 12px;
  color: #009feb;
}
</style>
